/** Calendrier DatePicker — noms de mois / jours (FR / AR) */
export const datePickerFr = {
  monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
  monthNamesShort: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
  dayNames: ['L', 'M', 'M', 'J', 'V', 'S', 'D'],
  required: 'Requis'
};

/** Gregorian month/day labels (not Hijri). Week starts Monday, aligned with FR. */
export const datePickerAr = {
  monthNames: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],
  dayNames: ['ن', 'ث', 'ر', 'خ', 'ج', 'س', 'ح'],
  weekdayNamesShort: ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
  required: 'مطلوب'
};
